"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationsSchema = exports.ContentResourceOrArraySchema = exports.ContentResourceSchema = exports.PositionSchema = exports.AudioTrackSourceSchema = exports.SubtitleSourceSchema = exports.TrackSourceSchema = exports.ContentOwnerSchema = exports.SomMarketingSchema = exports.SomMarketingVideoBlockSchema = exports.SomMarketingVideoBlock = void 0;
var zod_1 = require("zod");
var source_fetcher_1 = require("./source-fetcher");
exports.SomMarketingVideoBlock = zod_1.z.enum([
    'presplit',
    'preroll',
    'midroll',
    'postroll',
    'postsplit',
    'sponsor',
    'overlay',
    'pauseroll',
    'cutin',
]);
exports.SomMarketingVideoBlockSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    slots: zod_1.z.record(exports.SomMarketingVideoBlock, zod_1.z.object({
        enabled: zod_1.z.boolean(),
        count: zod_1.z.number().optional(),
    })),
    customConfig: zod_1.z
        .object({
        maxNonSponsorCount: zod_1.z.number(),
    })
        .optional(),
});
// https://sevenonemedia.github.io/adtec-se-docs/docs/desktop/desktop-setup.html#the-configobject
exports.SomMarketingSchema = zod_1.z.object({
    enabled: zod_1.z.boolean().optional(),
    device: zod_1.z
        .object({
        mode: zod_1.z.enum(['auto', 'mobile', 'desktop']),
        breakpoint: zod_1.z.number(), // threshold value to switch between mobile and desktop, when mode is 'auto'
    })
        .partial()
        .optional(),
    config: zod_1.z.object({
        id: zod_1.z.string(),
    }),
    taxonomy: zod_1.z
        .object({
        channels: zod_1.z.array(zod_1.z.string()),
        content: zod_1.z.enum(['content', 'gallery', 'video', 'liveticker']),
        topics: zod_1.z.object({}),
    })
        .optional(),
    video: zod_1.z
        .object({
        longplay: zod_1.z.boolean().optional(),
        blocks: zod_1.z
            .object({
            pre: exports.SomMarketingVideoBlockSchema,
            mid: exports.SomMarketingVideoBlockSchema,
            post: exports.SomMarketingVideoBlockSchema,
            overlay: exports.SomMarketingVideoBlockSchema.optional(),
            pause: exports.SomMarketingVideoBlockSchema.optional(),
        })
            .optional(),
        iabContent: source_fetcher_1.OpenRTBSchema.partial().optional(),
    })
        .optional(),
});
exports.ContentOwnerSchema = zod_1.z.object({
    name: zod_1.z.string(),
    url: zod_1.z.string(),
    logo: zod_1.z.string(),
});
exports.TrackSourceSchema = zod_1.z.object({
    id: zod_1.z.string().nullish(),
    url: zod_1.z.string().nullish(),
    label: zod_1.z.string().nullish(),
    language: zod_1.z.string().nullish(),
});
exports.SubtitleSourceSchema = exports.TrackSourceSchema;
exports.AudioTrackSourceSchema = exports.TrackSourceSchema.extend({
    role: zod_1.z.string().optional(),
});
exports.PositionSchema = zod_1.z.number();
exports.ContentResourceSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    contentType: zod_1.z.string(),
    contentOwner: exports.ContentOwnerSchema,
    upc: zod_1.z.string(),
    duration: exports.PositionSchema,
    start: exports.PositionSchema,
    end: exports.PositionSchema,
    introTimeRange: zod_1.z.tuple([exports.PositionSchema, exports.PositionSchema]),
    position: exports.PositionSchema,
    poster: zod_1.z.string(),
    thumbnail: zod_1.z.string(),
    title: zod_1.z.string(),
    sourceFetcherKey: zod_1.z.string(),
    overlayOffsets: zod_1.z.array(zod_1.z.union([zod_1.z.string(), exports.PositionSchema])),
    geolocation: zod_1.z.string(),
    subtitles: zod_1.z.record(zod_1.z.union([exports.SubtitleSourceSchema, zod_1.z.undefined()])),
    audioTracks: zod_1.z.record(zod_1.z.union([exports.AudioTrackSourceSchema, zod_1.z.undefined()])),
    somMarketing: exports.SomMarketingSchema,
    abTesting: source_fetcher_1.AbTestingSchema,
})
    .partial()
    .merge(source_fetcher_1.SourceFetcherResultSchema.omit({ error: true }));
exports.ContentResourceOrArraySchema = zod_1.z.union([
    exports.ContentResourceSchema,
    zod_1.z.array(exports.ContentResourceSchema),
]);
exports.RecommendationsSchema = zod_1.z.array(exports.ContentResourceSchema);
//# sourceMappingURL=content-resource.js.map